'use client';

import React from 'react';
import { useStockSection } from './StockSectionContext';

export default function StockSectionGate({
  sectionId,
  children,
}: {
  sectionId: string;
  children: React.ReactNode;
}) {
  const { isSectionVisible } = useStockSection();
  if (!isSectionVisible(sectionId)) return null;
  return <>{children}</>;
}
